import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Switch from "react-switch";
import Select from "react-select";
import { useParams } from "react-router-dom";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { useDispatch } from "react-redux";
import apiServiceHandler from "../../service/apiService";
import { updateRefreshCardData } from "../../redux/dripData";

const repeatOptions = [
  { value: "once", label: "Once" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "biweekly", label: "Bi-Weekly" },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: "none",
    border: state.isFocused ? "1px solid #ccc" : "1px solid #ddd",
    outline: "none",
    "&:hover": {
      border: "1px solid #aaa",
    },
  }),
};

const convertUtcToLocalDatetime = (utcDate) => {
  const date = new Date(utcDate);
  const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
  console.log(localDate.toISOString().slice(0, 16), 'localDate');
  return localDate.toISOString().slice(0, 16);
};

const TriggerModal = ({ isOpen, onClose, cardData }) => {
  const trigger = cardData?.trigger || {};

  const [startDate, setStartDate] = useState('');
  const [checked, setChecked] = useState(false);
  const [selectedAudiences, setSelectedAudiences] = useState([]);
  const [repeatSelectedOption, setRepeatSelectedOption] = useState(null);

  const { id } = useParams();
  const dispatch = useDispatch();
  const [groups, setGroups] = useState([]);

  const getAllGroups = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/groups", {});
      const formattedGroups = response.data.map((group) => ({
        value: group?._id,
        label: group?.name,
      }));

      setGroups(formattedGroups);
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  useEffect(() => {
    getAllGroups();
  }, []);

  useEffect(() => {
    if(cardData && cardData?.trigger?.trigger_date)
      setStartDate(convertUtcToLocalDatetime(cardData?.trigger?.trigger_date));
  }, [cardData]);

  useEffect(() => {
    if (groups.length > 0) {
      setSelectedAudiences(
        groups.filter((group) => (trigger.group_id || []).includes(group.value))
      );
    }

    if (trigger.repeat && trigger.repeat !== "off") {
      setChecked(true);
      setRepeatSelectedOption(
        repeatOptions.find((option) => option.value === trigger.repeat) || null
      );
    } else {
      setChecked(false);
      setRepeatSelectedOption(null);
    }
  }, [groups, trigger.group_id, trigger.repeat]);

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
  };

  const updateTriggerData = async () => {
    const payload = {
      trigger_date: new Date(startDate).toUTCString(),
      repeat: checked ? repeatSelectedOption?.value : "off",
      group_id: selectedAudiences.map((audience) => audience.value),
    };

    try {
      const response = await apiServiceHandler(
        "PATCH",
        `api/drip-compaign/${id}`,
        { trigger: payload }
      );
      if (response?.status) {
        toastr.success(response?.message);
        dispatch(updateRefreshCardData(true));
        onClose();
      }
    } catch (error) {
      console.error("Failed to update trigger:", error);
      toastr.error("Failed to update trigger. Please try again.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="md" centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title
          style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
        >
          <svg
            width="16"
            height="23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="icon__svg"
            preserveAspectRatio="xMidYMid meet"
            style={{ width: "20px", height: "20px", marginTop: "2px" }}
          >
            <path
              d="M3.003 0a.5.5 0 00-.373.832L6.268 4.67 1.142 6.642a1 1 0 00-.4 1.584l5.11 5.961-2.12.59a.751.751 0 00.017 1.45l6.5 1.75a.738.738 0 00.666-.154.75.75 0 00.264-.63l-.5-6.5a.749.749 0 00-1.399-.315L8.525 12l-2.48-3.15 5.315-2.002a.999.999 0 00.387-1.597L7.417.504A1.5 1.5 0 006.294 0H3.003zm12.12 12.573a.75.75 0 00-.406.11c-.782.463-1.299 1.002-1.577 1.585a2.615 2.615 0 00-.194 1.667c.074.346.222.584.357.83-1.109.76-1.584 1.775-1.608 2.62-.82-.21-1.926-.034-2.963.821-.2-.198-.387-.406-.7-.572a2.614 2.614 0 00-1.655-.276c-.637.107-1.297.454-1.958 1.078a.751.751 0 101.028 1.091c.504-.474.894-.642 1.178-.69.284-.047.494.01.702.121.417.222.702.673.702.673a.75.75 0 001.221.113c.917-1.073 1.546-1.05 2.081-.907.535.142.91.51.91.51a.75.75 0 001.189-.894s-.25-.462-.24-1.015c.012-.553.163-1.165 1.448-1.75a.75.75 0 00.228-1.204s-.354-.399-.452-.861a1.03 1.03 0 01.08-.708c.123-.26.391-.589.987-.941a.75.75 0 00-.358-1.4z"
              fill="#29353D"
            ></path>
          </svg>
          <span>Trigger</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields trigger-form">
          <div className="invite-form__field">
            <div className="text-input__label">Select Date</div>
            <div className="form-input__wrapper">
              <input
                type="datetime-local"
                className="form-input__input"
                required
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
          </div>
          <div
            className="invite-form__field date__repeat"
            style={{
              paddingTop: "1rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Repeat Trigger</span>
              <div>
                <Switch
                  checked={checked}
                  onChange={handleChange}
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
            </div>
            <div>
              {checked && (
                <Select
                  value={repeatSelectedOption}
                  onChange={setRepeatSelectedOption}
                  options={repeatOptions}
                  placeholder="Select repeat option"
                  styles={customStyles}
                />
              )}
            </div>
          </div>
          <div className="invite-form__field time--trigger--audience">
            <div style={{ fontSize: "16px", fontWeight: "600" }}>Audience</div>
            <div>
              <Select
                options={groups}
                isMulti
                value={selectedAudiences}
                onChange={setSelectedAudiences}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button className="send-invite__btn" style={{ background: "#fff" }}>
          <span className="send-invite-button__label">Delete</span>
        </button>
        <button className="send-invite__btn" onClick={updateTriggerData}>
          <span className="send-invite-button__label">Save</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TriggerModal;
